import styled from "styled-components";
import {Link} from "react-router-dom";


export const PharmaciesSelectItem = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  color: var(--gray-color);
  padding: .5rem;
  width: 100%;
  text-align: right;
  font-size: .9rem;

  &:not(.is-selected):hover {
    background: rgba(47, 204, 139, 0.1);
  }

  &.is-selected {
    background: #2eb378;
    color: #fff;

    span {
      color: rgba(255, 255, 255, 0.75);
    }
  }


  span {
    margin-right: .8rem;
    color: rgba(118, 133, 155, 0.75);
    display: inline-block;
  }
`;

export const DeleteRequestLink = styled(Link)`
  @media (max-width: 992px) {
    h3 {
      font-size: 1rem; 
      min-width: 102px;
    }
  }
`;

export const PharmaciesSelectedItem = styled.p`
  span {
    margin-right: .8rem;
    color: rgba(118, 133, 155, 0.75);
    display: inline-block;
    
    @media (max-width: 992px) {
      position: absolute;
      bottom: -32px;
      right: 0;
    }
  }
`;

export const LocationSelectContainer = styled.div`
  
  @media (max-width: 992px) {
    padding: 2.5rem 1.5rem 2.8rem;
    border-radius: 12px;
    background-color: #F8F9FA;
  }

`;
